// src/Dashboard/pages/user/Absences/components/AbsencesHero.jsx

import React from "react";
import {
  FaExclamationTriangle,
  FaNotesMedical,
  FaUserCheck,
  FaUserInjured,
} from "react-icons/fa";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>
      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}

export default function AbsencesHero({ stats, loading }) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-orange-500/30 blur-3xl" />

      <div className="relative">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          <FaNotesMedical className="text-[0.7rem]" />
          Suivi des absences
        </p>

        <div className="mt-3 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Absences, maladies & blessures
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Signalez rapidement une absence et pensez à confirmer le retour
              dès que l’adhérent reprend les cours.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:min-w-[360px]">
            <HeroStat
              icon={FaUserCheck}
              label="Actifs"
              value={loading ? "…" : stats.active}
            />

            <HeroStat
              icon={FaUserInjured}
              label="Absents"
              value={loading ? "…" : stats.absent}
            />

            <HeroStat
              icon={FaExclamationTriangle}
              label="À vérifier"
              value={loading ? "…" : stats.toConfirm}
            />
          </div>
        </div>
      </div>
    </section>
  );
}